angular.module('bmsApp.merrymaids').factory('MMInvoiceSvc', function ($q,
																	  CRUDSvc) {

	var self = {
		save: function (params) {
			return CRUDSvc.post('api/merrymaids/invoice/save', params);
		}

	};
	return self;

});
